import {JsonConverter, JsonCustomConvert} from 'json2typescript';
import {Json2TypescriptUtil} from '../util/json2TypescriptUtil';
import {SocialMedia} from '../model/social-sharing/socialMedia';
import {ThirdPartyShare} from '../model/social-sharing/thirdPartyShare';
import {Facebook} from '../model/social-sharing/facebook';
import {Download} from '../model/social-sharing/download';
import {Twitter} from '../model/social-sharing/twitter';

@JsonConverter
export class SocialMediaConverter implements JsonCustomConvert<Array<SocialMedia>> {

    deserialize(json: any): Array<SocialMedia> {

        const socialMediaArr = Array<SocialMedia>();
        // return
        /*const temp:TSMap<string,string>= new TSMap();
        for (const key of Object.keys(json)) {
            temp.set(key, json[key]);
        }

        return temp;*/

        for(const item of json) {
            switch(item.shareClass) {
                case 'thirdPartyShare': socialMediaArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,ThirdPartyShare));break;
                case 'facebook': socialMediaArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,Facebook));break;
                case 'twitter': socialMediaArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,Twitter));break;
                case 'download': socialMediaArr.push(Json2TypescriptUtil.getJsonConvertInstance().deserializeObject(item,Download));break;
            }

        }

        return socialMediaArr;
    }

    serialize(data: Array<SocialMedia>): any {
        return JSON.stringify(data);
    }
}
